// KL - ceiling cassette aircond service (mount-type page).
const content = {
    slug: 'ceiling-cassette-aircond-service',
    title: (c) => `Ceiling Cassette Aircond Service KL from ${c.money(c.tables.general[0].ducted)}`,
    description: (c) =>
        `Ceiling cassette aircond service in KL: general service from ${c.money(c.tables.general[0].ducted)}, chemical wash ${c.money(c.tables.chemicalWash[0].ducted)}. Living halls, shops and offices.`,
    eyebrow: 'KL · Ceiling cassette',
    h1: 'Ceiling Cassette Aircond Service in KL',
    lead: (c) =>
        `The square, four-way unit in the ceiling of your living hall, shop or office needs more than a wipe of the grille. General service from ${c.money(c.tables.general[0].ducted)}, chemical wash from ${c.money(c.tables.chemicalWash[0].ducted)}.`,
    image: 'blog/living/aircon/ceiling-cassette-aircon-servicing.jpg',
    imageAlt: 'Ceiling cassette aircond being serviced in a living hall',
    facts: ['Living halls, shops, offices', 'Ladder work included', 'Drain pump checked'],
    priceTitle: 'Ceiling cassette prices',
    priceIntro: 'Cassettes take longer than wall units: the panel comes down, and the drain pump and tray are cleaned overhead.',
    panel: { type: 'servicing', services: ['general', 'chemicalWash', 'chemicalOverhaul'], defaultMount: 'Ceiling' },
    sections: [
        {
            title: 'Where you find cassettes in KL',
            cards: [
                { title: 'Landed homes', body: 'Double-storey terraces, semi-Ds and bungalows often cool the living and dining hall with one or two 2.0-3.0hp cassettes.' },
                { title: 'Shops and cafes', body: 'Shoplots across KL use cassettes for even cooling across an open floor.' },
                { title: 'Offices', body: 'Small offices and clinics in commercial blocks rely on cassettes in each room.' },
            ],
        },
        {
            title: 'What\'s different about servicing a cassette',
            tone: 'muted',
            items: [
                'The front grille and panel are lowered from the ceiling.',
                'The filter and coil are cleaned overhead with a catch bag to protect the floor.',
                'The built-in drain pump is tested - a failed pump is the most common cause of cassette leaks.',
                'The drain tray, which sits directly over your floor, is flushed clean.',
            ],
        },
        {
            title: 'Cassette dripping from the ceiling?',
            paragraphs: [
                'Cassettes pump their condensate up and out, so when the pump fails or the tray clogs, water falls straight from the ceiling. If you see drips or hear the pump buzzing constantly, switch the unit off and book a service - the technician checks the pump and float switch.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is ceiling cassette aircond service in KL?',
            answer: (c) => `A general service costs ${c.money(c.tables.general[0].ducted)} for one cassette and ${c.money(c.tables.general[1].ducted)} for two. A chemical wash costs ${c.money(c.tables.chemicalWash[0].ducted)} per cassette.`,
        },
        {
            question: 'How often should a cassette be serviced?',
            answer: 'Every three months for shops and cafes running long hours, and every four to six months for home living halls.',
        },
        {
            question: 'Do you service ducted aircond too?',
            answer: 'Yes. Tell us the unit type in your booking notes - ducted units are priced like cassettes.',
        },
    ],
    schema: {
        name: 'Ceiling Cassette Aircond Service in Kuala Lumpur',
        serviceType: 'Cassette air conditioner servicing',
        offers: (c) => [
            { name: 'Cassette general service, 1 unit', price: c.tables.general[0].ducted },
            { name: 'Cassette general service, 2 units', price: c.tables.general[1].ducted },
            { name: 'Cassette chemical wash, 1 unit', price: c.tables.chemicalWash[0].ducted },
        ],
    },
}

export default content
